import Allowances from './allowances';
import Bands from './bands';
import StudentLoan from './student-loan';

export default class TaxYear {
    constructor(taxYear) {
        this.taxYear = taxYear.taxYear;
        this.allowances = new Allowances(taxYear.allowances);
        this.taxBands = new Bands(taxYear.tax);
        this.nationalInsurance = new Bands(taxYear.nationalInsurance);
        this.studentLoan = new StudentLoan(taxYear.studentLoan);
        this.apprenticeshipLevy = 0;

        if ('employerNationalInsurance' in taxYear) {
            this.employerNationalInsurance = new Bands(taxYear.employerNationalInsurance);
        }

        if ('apprenticeshipLevy' in taxYear) {
            this.apprenticeshipLevy = taxYear.apprenticeshipLevy;
        }
    }
}